import QrCode from 'qrcode.react';
import './estilos.css';
function QrCard({ qrRef, url, bgColor, qrColor, customImg, noImg }) {
	let imgCustom = undefined;

	noImg
		? (imgCustom = null)
		: customImg 
		? (imgCustom = customImg)
		: (imgCustom = 'https://s3.amazonaws.com/www.codeflex.lat/documentos/a423d4ef-3dfb-40a1-9b02-d74ec10e9329/codeflex.jpg');

	const ventana = () => {
		window.open("https://lector.primerosauxilios.online/", "_top");
	  }; 
 
	return (
		<article className="card">
			<div
				className="qr-box"
				ref={qrRef}
				style={{ backgroundColor: bgColor }}
			>
				<QrCode 
					size={250}
					value={url ? url : 'https://www.codeflex.com.co'}
					bgColor={bgColor}
					fgColor={qrColor}
					level="H"
					includeMargin
					imageSettings={{
						src: imgCustom,
						height: 45,
						width: 45, 
						excavate: true, 
					}}
				/> 
			</div> 
			<h2 className="word-wrap">{url ? url : 'www.codeflex.com.co'}</h2>
			<p>
				Ingrese la URL de su sitio, <strong id='rojo'> Elige una imagen o selecciona el checkbox para descargar sin imagen, elige una de las 2 opciones antes de descargar.</strong>.
			</p>

		</article>

	);
	
}

export default QrCard;
